import React__default, { useState, useEffect } from 'react';
import styles from './Slider.module.scss.js';
import '../../../styles/forms.css.js';
import classNames from 'classnames';
import '../../../styles/general.css.js';
import '../../DataDisplay/Table/Table.js';
import '../../DataDisplay/TextTruncate/TextTruncate.module.css.js';
import '../../../styles/fonts.css.js';
import '../../Layout/Tooltip/Tooltip.js';
import '../Button/Button.module.scss.js';
import Typography from '../../DataDisplay/Typography/Typography.js';

const Slider = ({ min = 0, max = 100, step = 1, width = '100%', showValue = true, sliderType = 'default', valueSufix = '', valuePrefix = '', typographyTag = 'textextrasmall', typographyColor = '#666666', defaultValue, ...props }) => {
    const [value, setValue] = useState(defaultValue ? defaultValue : min);
    const handleChange = (event) => {
        setValue(Number(event.target.value));
        if (props.onChange) {
            props.onChange(event);
        }
    };
    useEffect(() => {
        if (defaultValue) {
            let value = defaultValue;
            if (value > max)
                value = max;
            if (value < min)
                value = min;
            setValue(value);
        }
    }, [defaultValue, max, min]);
    return (React__default.createElement("div", { className: classNames(styles.Slider, styles.numbersRight) },
        React__default.createElement("div", { className: "all-centered" },
            React__default.createElement("input", { className: sliderType === 'minimized' ? styles.sliderMin : styles.sliderNormal, style: { width: width }, id: props.id, step: step, type: "range", min: min, max: max, value: value, onChange: handleChange })),
        showValue ? (React__default.createElement(Typography, { tag: typographyTag, color: typographyColor },
            React__default.createElement("div", { className: "all-centered", style: {
                    marginLeft: 10,
                    alignItems: 'left',
                    justifyContent: 'left',
                    minWidth: 50,
                } },
                valuePrefix,
                value,
                valueSufix))) : null));
};

export { Slider as default };
//# sourceMappingURL=Slider.js.map
